import Card from './Card';
import CardTitle from './CardTitle';
import CardText from './CardText';

export default Card;

export {
  CardTitle,
  CardText,
};
